import React from "react";
import {
  TelegramShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookShareButton,
} from "react-share";

import {
  Box,
  Grid,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import TelegramIcon from "@material-ui/icons/Telegram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import FacebookIcon from "@material-ui/icons/Facebook";

import ShortLinkInput from "./ShortLinkInput";

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: "#f7f7f7",

    margin: ".5rem 0",
    padding: "2rem 0",
  },
  textBox: {
    "& .MuiIconButton-root": { backgroundColor: "#f7f7f7 !important" },
    width: "80%",
    margin: " auto",
    display: "flex",
    justifyContent: "center",
  },

  boldText: {
    fontFamily: "Vazir",
    marginBottom: "2rem",
  },
  icon: {
    fontSize: "4rem",
  },
  linkBox2: {
    display: "flex",
    justifyContent: "center",
  },
}));

export default function ShareBox({ link, data, slug, orgData }) {
  const classes = useStyles();
  let myLink = link;
  if (!link) {
    myLink = `https://agapengo.com/payment-methods/${data}/${slug}`;
  }
  return (
    <Grid container className={classes.root} direction="column">
      <Grid item>
        <Box className={classes.textBox}>
          <TelegramShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#D4DEF0",
              }}
            >
              <TelegramIcon
                style={{ color: "#356db5" }}
                className={classes.icon}
              />
            </IconButton>
          </TelegramShareButton>
          <EmailShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#F8D1DD",
              }}
            >
              <EmailIcon
                style={{ color: "#f32852" }}
                className={classes.icon}
              />
            </IconButton>
          </EmailShareButton>
          <LinkedinShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#CAE0F0",
              }}
            >
              <LinkedInIcon
                style={{ color: "#0073b2" }}
                className={classes.icon}
              />
            </IconButton>
          </LinkedinShareButton>
          <WhatsappShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#CCEEDA",
              }}
            >
              <WhatsAppIcon
                className={classes.icon}
                style={{ color: "#0dc143" }}
              />
            </IconButton>
          </WhatsappShareButton>
          <FacebookShareButton url={myLink}>
            <IconButton
              aria-label="delete"
              style={{
                backgroundColor: "#BDCDEC",
              }}
            >
              <FacebookIcon
                className={classes.icon}
                style={{ color: "#4267B2", borderRadius: "50%" }}
              />
            </IconButton>
          </FacebookShareButton>
        </Box>
      </Grid>
      <div>
        <div className={classes.linkBox2}>
          <ShortLinkInput link={myLink} />
        </div>
      </div>
    </Grid>
  );
}
